"use strict";

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);

/**
 * @description Base class object.
 *
 * super mixin : thanks to maxbrunsfeld - https://gist.github.com/1542120
 * extend : thanks to backbone - http://backbonejs.org/
 *
 */
ngModule.factory("Class", function () {
  var Class = function Class() {
    this.initialize && this.initialize.apply(this, arguments);
  };
  _.extend(Class.prototype, {
    // The super method takes two parameters: a method name
    // and an array of arguments to pass to the overridden method.
    // This is to optimize for the common case of passing 'arguments'.
    _super: function _super(methodName, args) {
      // Keep track of how far up the prototype chain we have traversed,
      // in order to handle nested calls to _super.
      this._superCallObjects || (this._superCallObjects = {});
      var currentObject = this._superCallObjects[methodName] || this,
        parentObject = this.__findSuper__(methodName, currentObject);
      if (!parentObject || !parentObject[methodName]) {
        throw "No parent implementation found for method " + methodName;
      }
      this._superCallObjects[methodName] = parentObject;
      var result = parentObject[methodName].apply(this, args || []);
      delete this._superCallObjects[methodName];
      return result;
    },
    // Find the next object up the prototype chain that has a
    // different implementation of the method.
    __findSuper__: function __findSuper__(methodName, childObject) {
      var object = childObject;
      while (object[methodName] === childObject[methodName]) {
        object = object.constructor.__super__;
      }
      return object;
    }
  });

  // Helper function to correctly set up the prototype chain, for subclasses.
  // Similar to `goog.inherits`, but uses a hash of prototype properties and
  // class properties to be extended.
  var extend = function extend(protoProps, staticProps) {
    var parent = this;
    var child;

    // The constructor function for the new subclass is either defined by you
    // (the "constructor" property in your `extend` definition), or defaulted
    // by us to simply call the parent's constructor.
    if (protoProps && _.has(protoProps, 'constructor')) {
      child = protoProps.constructor;
    } else {
      child = function child() {
        return parent.apply(this, arguments);
      };
    }

    // Add static properties to the constructor function, if supplied.
    _.extend(child, parent, staticProps);

    // Set the prototype chain to inherit from `parent`, without calling
    // `parent`'s constructor function.
    var Surrogate = function Surrogate() {
      this.constructor = child;
    };
    Surrogate.prototype = parent.prototype;
    child.prototype = new Surrogate();

    // Add prototype properties (instance properties) to the subclass,
    // if supplied.
    if (protoProps) {
      _.extend(child.prototype, protoProps);
    }

    // Set a convenience property in case the parent's prototype is needed later.
    child.__super__ = parent.prototype;
    return child;
  };
  Class.extend = extend;
  return Class;
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/core/classes/class.js
// module id = 2694
// module chunks = 13